import '../../styles/App.css';

export default function Unaffiliated() {
        return (
            <>
                <div class="flex unselectable" id="unaffiliated-notice">
                    <h3>This site is unaffiliated with SPT (Strathclyde Partnership for Transport) and unofficially provides these data visualizations and APIs. However, data used is from an <span><a class="underline_highlight" href="https://www.railwaydata.co.uk/timetables/glasgow/aug24/GlasgowSubwayTimetable.pdf">official source.</a></span></h3>
                </div>
            </>
        )
}